import { reportModalActionTypes } from './Constants';

export function toggleReportModal(data) {
	return {
		type: reportModalActionTypes.TOGGLE_REPORT_MODAL,
		payload: { data },
	};
}

export function getReportOptionsRequest(data) {
	return {
		type: reportModalActionTypes.GET_REPORT_OPTIONS_REQUEST,
		payload: { data },
	};
}

export function getReportOptionsSuccess(data) {
	return {
		type: reportModalActionTypes.GET_REPORT_OPTIONS_SUCCESS,
		payload: { data },
	};
}

export function getReportOptionsError(error) {
	return {
		type: reportModalActionTypes.GET_REPORT_OPTIONS_ERROR,
		payload: { error },
	};
}

export function sendReportRequest(data) {
	return {
		type: reportModalActionTypes.SEND_REPORT_REQUEST,
		payload: { data },
	};
}

export function sendReportSuccess(data) {
	return {
		type: reportModalActionTypes.SEND_REPORT_SUCCESS,
		payload: { data },
	};
}

export function sendReportError(error) {
	return {
		type: reportModalActionTypes.SEND_REPORT_ERROR,
		payload: { error },
	};
}

export function setReportItemId(data) {
	return {
		type: reportModalActionTypes.SET_REPORT_ITEM_ID,
		payload: { data },
	};
}
